import { WorldPoint, Direction } from './grid';

export type PQueueRecord<T> = {
    distance: number
    data: T
}

export class PQueue<T> {
    private stack: PQueueRecord<T>[] = []

    public push(rec: PQueueRecord<T>): void {
        for (var i = 0; i < this.stack.length; i += 1) {
            if (rec.distance < this.stack[i].distance) {
                this.stack.splice(i, 0, rec)
                return
            }
        }

        this.stack.push(rec)
    }

    public pop(): PQueueRecord<T> | null {
        const r = this.stack.shift()
        if (r == undefined) {
            return null
        } else {
            return r
        }
    }
}
